<template>
  <div>
    <el-popover
      placement="top-start"
      trigger="hover"
      popper-class="layout-popover"
      v-model="networkVisible"
    >
      <div class="network-list">
        <div class="title">
          <img
            v-if="isOnline && netInfo.timeDelay < networkThreshold"
            src="@saas/pages/assets/images/live/wifi-normal.png"
            alt=""
          />
          <img
            v-else-if="isOnline && netInfo.timeDelay >= networkThreshold"
            src="@saas/pages/assets/images/live/wifi-bad.png"
            alt=""
          />
          <img v-else src="@saas/pages/assets/images/live/wifi-no.png" alt="" />
          <span v-if="isOnline && netInfo.timeDelay < networkThreshold"
            >网络正常</span
          >
          <span v-else-if="isOnline && netInfo.timeDelay >= networkThreshold"
            >网络差</span
          >
          <span v-else>无网络</span>
        </div>
        <div class="net-item">
          <div class="label">延时</div>
          <div class="value">{{ netInfo.timeDelay }}ms</div>
        </div>
        <div class="net-item">
          <div class="label">丢包率</div>
          <div class="value">
            上行 {{ netInfo.upLoss }}%, 下行 {{ netInfo.downLoss }}%
          </div>
        </div>
        <div class="net-footer">
          <el-button type="primary" @click="onClickCheck">检测</el-button>
          <el-button type="primary" @click="onClickReport">上报</el-button>
          <el-button type="primary" @click="onClickCopy">复制</el-button>
        </div>
      </div>
      <div slot="reference">
        <img
          class="reference-img"
          v-if="isOnline && netInfo.timeDelay < networkThreshold"
          src="@saas/pages/assets/images/live/wifi-normal.png"
          alt=""
        />
        <img
          class="reference-img"
          v-else-if="isOnline && netInfo.timeDelay >= networkThreshold"
          src="@saas/pages/assets/images/live/wifi-bad.png"
          alt=""
        />
        <img
          class="reference-img"
          v-else
          src="@saas/pages/assets/images/live/wifi-no.png"
          alt=""
        />
      </div>
    </el-popover>
    <network-check
      v-if="networkCheckVisible"
      class="platform-check"
      @close="networkCheckVisible = false"
    ></network-check>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { copyText } from "@saas/components/src/utils/utils";
import NetworkCheck from "@saas/components/src/components/network-check/Index.vue";
import ScreenShareMixins from "../mixins/screen-share";
import { NetworkDetector } from "@saas/components/src/utils/network-check";
import { uploadLiveLog } from "@saas/components/src/utils/log";
export default {
  mixins: [ScreenShareMixins],
  components: {
    NetworkCheck,
  },
  data() {
    return {
      networkCheckVisible: false,
      networkVisible: false,
      networkThreshold: 500, // 网络差阀值
      isOnline: true,
      netInfo: {
        timeDelay: 0,
        upLoss: 0,
        downLoss: 0,
      },
      // 完整 QoS 数据（包含码率、帧率、分辨率等扩展字段）
      fullQosData: null,
      networkDetector: null,
    };
  },
  mounted() {
    // 监听 online 事件
    // window.addEventListener("online", this.checkNetworkStatus);
    // // 监听 offline 事件
    // window.addEventListener("offline", this.checkNetworkStatus);
    this.isOnline = navigator.onLine;
    // 监听网络状态变化
    this.networkDetector = new NetworkDetector({
      timeout: 10000, // 10秒超时
      checkInterval: 1000 * 30, // 30秒检查一次
      checkUrl: "/ProxyAdmin/health", // 自定义检测URL
    });
    this.networkDetector.on("statusChange", (data) => {
      console.log("djj_network", data);

      if (data.isOnline) {
        this.isOnline = true;
        console.log("网络已恢复");
      } else {
        this.isOnline = false;
        console.log("网络连接异常");
      }
      this.setNetworkOnline(data.isOnline);
    });

    // 开始监控
    this.networkDetector.startMonitoring();
  },
  beforeDestroy() {
    // window.removeEventListener("online", this.checkNetworkStatus);
    // window.removeEventListener("offline", this.checkNetworkStatus);
    // 停止监控
    this.networkDetector.stopMonitoring();
    this.liveService.off("statistics", this.onStatistics);
  },
  computed: {
    ...mapState("live", ["liveService", "roomInfo"]),
    userInfo() {
      return this.$store.getters.user || {};
    },
  },
  watch: {
    liveService: {
      handler(val) {
        if (val) {
          this.liveService.on("statistics", this.onStatistics);
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations("live", ["setNetworkOnline"]),
    onStatistics(statistics) {
      this.netInfo = {
        timeDelay: statistics.rtt,
        upLoss: statistics.upLoss,
        downLoss: statistics.downLoss,
      };
      this.fullQosData = statistics;
    },
    checkNetworkStatus() {
      this.isOnline = navigator.onLine;
    },
    onClickCheck() {
      uploadLiveLog({
        message: "用户点击网络检测",
        extra: {
          component: "Wifi",
          action: "click_wifi_check",
          netInfo: this.netInfo,
          isOnline: this.isOnline,
        },
      });

      this.networkVisible = false;
      this.networkCheckVisible = true;
      //   this.$emit("netCheck");
      //   this.networkCheckVisible = true;
    },
    onClickReport() {
      const reportData = {
        // 网络基础
        isOnline: this.isOnline,
        networkType: navigator.connection?.effectiveType || "unknown",
        // 实时 QoS
        rtt: this.netInfo.timeDelay,
        upLoss: this.netInfo.upLoss,
        downLoss: this.netInfo.downLoss,
        // 扩展 QoS（码率、帧率、分辨率等）
        ...(this.fullQosData || {}),
        // 设备环境
        userAgent: navigator.userAgent,
        screenResolution: `${window.screen.width}x${window.screen.height}`,
        // 业务上下文
        roomId: this.roomInfo?.id,
        userId: this.userInfo?.user_id,
      };

      uploadLiveLog({
        message: "用户一键上报网络诊断",
        tag: "qos_report",
        extra: {
          component: "Wifi",
          action: "click_wifi_report",
          ...reportData,
        },
      }, true);

      this.$darkMessage.success("上报成功");
      this.networkVisible = false;
    },
    onClickCopy() {
      uploadLiveLog({
        message: "用户点击网络复制",
        extra: {
          component: "Wifi",
          action: "click_wifi_copy",
          netInfo: this.netInfo,
          isOnline: this.isOnline,
          roomId: this.roomInfo?.id,
        },
      });

      // 创建包含换行的文本
      const textToCopy = `
      roomId: ${this.roomInfo.id}
      UserId：${this.userInfo.user_id}
      延时：${this.netInfo.timeDelay}ms
      丢包率：上行 ${this.netInfo.upLoss}%，下行 ${this.netInfo.downLoss}%`;
      try {
        // 使用 Clipboard API 复制文本
        copyText(textToCopy).then(() => {
          this.$darkMessage.success("复制成功");
          this.networkVisible = false;
        });
      } catch (err) {
        this.$darkMessage.error("复制失败");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.reference-img {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.network-list {
  width: 327px;
  background: #18181b;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  display: flex;
  flex-direction: column;
  padding: 16px;
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    height: 28px;
    font-size: 18px;
    color: #c9cdd4;
    img {
      width: 20px;
      height: 20px;
      margin-right: 12px;
    }
  }
  .net-item {
    height: 36px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .label {
      font-weight: 400;
      font-size: 14px;
      color: #a1a1aa;
    }
    .value {
      font-weight: 500;
      font-size: 14px;
      color: #ecedee;
    }
  }
  .net-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-button {
      flex: 1;
      margin-top: 16px;
      border-radius: 12px;
      border: none;

      &:first-child {
        background: #3f3f46;
        color: #ecedee;
        &:hover {
          background: #3f3f46 !important;
        }
        &:active {
          background: #3f3f46 !important;
        }
        &:focus {
          background: #3f3f46 !important;
        }
      }
      &:nth-child(2) {
        background: #b45309;
        color: #e8f3ff;
        &:hover {
          background: #b45309 !important;
        }
        &:active {
          background: #b45309 !important;
        }
        &:focus {
          background: #b45309 !important;
        }
      }
      &:last-child {
        background: #0e42d2;
        color: #e8f3ff;
        &:hover {
          background: #0e42d2 !important;
        }
        &:active {
          background: #0e42d2 !important;
        }
        &:focus {
          background: #0e42d2 !important;
        }
      }
    }
  }
}
.platform-check {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
</style>
<style lang="scss">
.layout-popover {
  background: #18181b;
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(229, 231, 235, 0.04) !important;
  box-shadow: 0px 8px 60px 2px rgba(0, 0, 0, 0.8) !important;
  padding: 0;
  z-index: 9999;
  .popper__arrow {
    display: none;
  }
}
</style>
